import ReactMarkdown from "react-markdown";
import { Link } from "react-ui";
import * as React from "react";

import { FileException } from "./UploadFile.styles";

export const UploadFileException = (props: { errorMessage: string }): JSX.Element => {
    const textNode = (
        <ReactMarkdown
            components={{
                p: ({ node: _, ...properties }) => <p style={{ margin: 0 }} {...properties} />,
                a: ({ href, children }) => (
                    <Link href={href} target="_blank" rel="noreferrer">
                        {children}
                    </Link>
                ),
            }}>
            {props.errorMessage ?? ""}
        </ReactMarkdown>
    );

    return <FileException>{textNode}</FileException>;
};
